export default __webpack_public_path__ + "static/media/childhood-memory.b9511a76.mp3";